import {createAction} from 'redux-actions';
import {apiPost} from '../api';

const actions = {
  change_type_submit: createAction('CHANGE_TYPE_SUBMIT'),
  change_type_succeeded: createAction('CHANGE_TYPE_SUCCEEDED'),
  change_type_failed: createAction('CHANGE_TYPE_FAILED'),
  change_type_reset: createAction('CHANGE_TYPE_RESET'),
};

export default actions;

export const changeType = data => apiPost('agent/api/lead/change-type', data, actions.change_type_submit, actions.change_type_succeeded, actions.change_type_failed);
export const resetChangeType = () => {
  return {
    type: actions.change_type_reset.toString(),
  };
};